import {ucFirst} from './strings.ts';

const DEFAULT_LOCALE = 'no-NO';
const DEFAULT_TIMEZONE = 'Europe/Oslo';

export function fullDate(value: string | Date, locale = DEFAULT_LOCALE) {
	const date = toDate(value);
	return ucFirst(
		date.toLocaleDateString(locale, {
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric'
		})
	);
}

export function shortDate(value: string | Date, locale = DEFAULT_LOCALE) {
	const date = toDate(value);
	return ucFirst(
		date.toLocaleDateString(locale, {
			weekday: 'long',
			month: 'long',
			day: 'numeric'
		})
	);
}

export function time(value: string | Date, locale = DEFAULT_LOCALE) {
	const date = toDate(value);
	return date.toLocaleTimeString(locale, {
		hour: '2-digit',
		minute: '2-digit'
	});
}

export function dateTime(value: string | Date, locale = DEFAULT_LOCALE) {
	if (!value) {
		return '';
	}

	const date = toDate(value);
	const weekday = ucFirst(date.toLocaleDateString(locale, {weekday: 'long'}));
	const dayMonth = date.toLocaleDateString(locale, {day: 'numeric', month: 'long'});
	const time = date.toLocaleTimeString(locale, {hour: '2-digit', minute: '2-digit'});
	return `${weekday} ${dayMonth} ${time}`;
}

export function shiftDate(date: Date, days: number) {
	const result = new Date(date);
	result.setUTCDate(result.getUTCDate() + days);
	return result;
}

export function shiftDateBack(date: Date, days: number) {
	const result = new Date(date);
	result.setUTCDate(result.getUTCDate() - days);
	return result;
}

export function startDate(date: Date, timeZone = DEFAULT_TIMEZONE): string {
	const dateStr = getDateInTimezone(date, timeZone);
	const midnightUTC = new Date(`${dateStr}T00:00:00.000Z`);
	const offsetMs = getTimezoneOffsetMs(midnightUTC, timeZone);
	return new Date(midnightUTC.getTime() - offsetMs).toISOString();
}

export function endDate(date: Date, timeZone = DEFAULT_TIMEZONE): string {
	const dateStr = getDateInTimezone(date, timeZone);
	const endUTC = new Date(`${dateStr}T23:59:59.999Z`);
	const offsetMs = getTimezoneOffsetMs(endUTC, timeZone);
	return new Date(endUTC.getTime() - offsetMs).toISOString();
}

function getTimezoneOffsetMs(date: Date, timeZone: string): number {
	const utcString = date.toLocaleString('en-US', {timeZone: 'UTC'});
	const tzString = date.toLocaleString('en-US', {timeZone});
	return new Date(tzString).getTime() - new Date(utcString).getTime();
}

export function ymd(value: string | Date = new Date(), timeZone = DEFAULT_TIMEZONE) {
	return getDateInTimezone(value, timeZone);
}

export function getDateInTimezone(value: string | Date, timeZone: string) {
	return new Intl.DateTimeFormat('en-CA', {
		timeZone,
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	}).format(toDate(value));
}

function toDate(value: string | Date) {
	if (value instanceof Date) {
		return value;
	}

	return new Date(value);
}
